import React from 'react';

import getColor from '../../../utils/getColor';
import styles from './styles/button-text.module.css';

export default function ButtonText({ height, status, iconSize, leadingIcon, trailingIcon, text, handleClick }) {
    const size = iconSize || '16px';

    const getTextColor = () => {
        if (status) return getColor(status);

        return 'var(--gray-dark)';
    };

    return (
        <button
            className={styles.wrapper}
            style={{ color: getTextColor() }}
            data-type={height}
            data-status={handleClick ? '' : 'inactive'}
            onClick={handleClick}
        >
            {leadingIcon && 
                <div style={{ width: size, height: size, color: getTextColor() }}>
                    {leadingIcon}
                </div>
            }
            {text}
            {trailingIcon &&
                <div style={{ width: size, height: size, color: getTextColor() }}>
                    {trailingIcon}
                </div>
            }
        </button>
    );
}
